import { api } from './client';
import { stringifyParams } from '@/lib/utils';
import type { ApiResponse } from '@/types/api';
import type {
  SettingExcelSearchParameters,
  SettingExcelParameters,
  SettingExcel
} from '@/types/setting';

/**
 * 설정 가져오기
 * @param params 
 * @returns 
 */
export async function getSettingExcel(params: SettingExcelSearchParameters): Promise<ApiResponse<SettingExcel>> {
  const stringParams = stringifyParams(params);
  return api.get<SettingExcel>(`/settings/excel`, { params: stringParams });
}

/**
 * 임직원 등급 설정값 수정
 * @param id 수정할 임직원 ID
 * @param data 수정할 임직원 정보
 * @returns 
 */
export async function updateSettingExcel(data: Partial<SettingExcelParameters>): Promise<ApiResponse<SettingExcel>> {
  return api.put<SettingExcel>(`/settings/excel`, { body: data });
}

/**
 * 임직원 등급 설정값 등록
 * @param data 
 * @returns 
 */
export async function createSettingExcel(data: Partial<SettingExcelParameters>): Promise<ApiResponse<SettingExcel>> {
  return api.post<SettingExcel>(`/settings/excel`, { body: data });
}